<template>
  <div>
    <div v-if="!getClub.recapitulatifs || !getClub.recapitulatifs.length>0">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-body">
              <p>
                Pas de récapitulatifs pour ce club
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form role="form" v-if="getClub.recapitulatifs && getClub.recapitulatifs.length>0">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <b-col md="9" class="my-1">
                <h3 class="box-title"> {{ getClub.recapitulatifs.length }} récapitulatifs</h3>
              </b-col>
              <b-col md="3" class="my-1">
                <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
              </b-col>
            </div>
            <div class="box-body">
              <b-table
                id="tableListingAllRecaps"
                v-if="getClub.recapitulatifs.length>0"
                responsive bordered striped hover
                :items="getClub.recapitulatifs"
                :current-page="pagination_meta.current_page"
                :filter="filter"
                :fields="columnsListingRecap"
                :per-page="pagination_meta.per_page"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :empty-text="'Aucun résultat'"
                :empty-filtered-text="'Aucun résultat'"
                foot-clone
                show-empty
                @filtered="onListingFiltered"
              >

                <template slot="actions" slot-scope="row">
                  <router-link
                    class="btn btn-default padding2"
                    :to="{ name: 'Recap', params: { recap_id: row.item.id }}">
                    <i class="glyphicon glyphicon-pencil"></i>
                  </router-link>
                </template>
                <template slot="id" slot-scope="row">
                  <router-link
                    :to="{ name: 'Recap', params: { recap_id: row.item.id }}">
                    Récapitulatif {{ row.item.id | idFormat }}
                  </router-link>
                </template>
                <template slot="statut" slot-scope="data">
                                <span
                                  :class="getClassNameRecap(data.item.statut.type)">
                                    {{ data.item.statut.type }}
                                </span>
                </template>
                <template slot="nombre_licence" slot-scope="data">
                  {{ data.item.licences.length }}{{ data.item.licences.length > 1 ? " membres" : " membre" }}
                </template>
                <template slot="total" slot-scope="data">
                  {{ data.item.total | idFormat }}€
                </template>
              </b-table>
              <b-pagination size="md"
                            :total-rows="getClub.recapitulatifs.length"
                            v-model="pagination_meta.current_page"
                            :per-page="pagination_meta.per_page">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>


import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import Datepicker from 'vuejs-datepicker';

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');
import '../../../utils'

export default {
  data() {
    return {
      sortBy: null,
      sortDesc: true,
      dataTableRankingMember: null,
      filter: null,
      loadingFicheIndividuelleResultat: false,
      pagination_meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 20,
        to: 1,
        total: 1
      },
      columnsListingRecap: [
        {
          label: 'Date',
          key: 'date',
          sortable: false,
        },
        {
          label: 'Numéro',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Numéro Comptable',
          key: 'numero_comptable',
          sortable: true,
        },
        {
          label: 'Nombre de licences',
          key: 'nombre_licence',
          sortable: false,
        },
        {
          label: 'Statut',
          key: 'statut',
          sortable: true,
        },
        {
          label: 'Total',
          key: 'total',
          sortable: false,
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      getClub: 'getClub',
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    var these = this

  },
  created() {
  },
  watch: {},
  components: {},
  methods: {
    ...mapActions({}),
    onListingFiltered(filteredItems) {
      if (this.filter != "") {
        this.pagination_meta.total = filteredItems.length
        this.pagination_meta.currentPage = 1
      } else {
        this.getTableListingRecap();
      }
    },
    getClassNameRecap: function (statut) {
      return this.$getClassNameRecap(statut)
    },
    flatten: function (obj) {
      var root = {};
      (function tree(obj, index) {
        var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) continue;
          root[index + key + suffix] = obj[key];
          if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
          if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
        }
      })(obj, "");
      return root;
    },
    sortCompareAdvanced: function (a, b, key) {
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else {
        // Stringify the field data and use String.localeCompare
        return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
          numeric: true
        })
      }
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/ListingRecapitulatifs.vue